const AttestationServicess = () => {
  return (
    <div>
      <div className="flex flex-col justify-center items-center">
        <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]" />
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
          <div className="flex flex-col justify-center">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
              Attestation Services
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              TCS offers cost-effective and hassle-free document attestation
              services. The entire procedure—from administration, to the
              verification and the delivery of attested documents—has been
              designed to provide ease, reliability, and security, whilst making
              sure that documents are delivered on time.
            </p>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              The service covers all major, local, secondary and higher
              education boards, vocational training bodies, private educational
              organisations, HEC, local and international universities, personal
              identification and family certificates, financial, trade and
              medical organisations, and the travel documents and certificates
              for Pakistanis abroad.
            </p>
          </div>
          <div className="flex-1 flex flex-col justify-center items-center sm:mt-[0rem] mt-[1rem]">
            <img
              src="/DomesticScrollingBanner/image11.jpg"
              alt=""
              className="rounded-md max-w-[100%]"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default AttestationServicess;
